import { Icon } from '../icons';
import { useSurvey } from '../SurveyContext';

export function PetsStep() {
  const surveyFlow = useSurvey();
  const types = ['Dog', 'Cat', 'Bird', 'Fish', 'Reptile'];
  const none = surveyFlow.answers._petsAnswered && surveyFlow.answers.pets.length === 0;
  return (
    <div className="intake-pets">
      {types.map((t) => (
        <button type="button"
          key={t}
          className="intake-pet"
          aria-pressed={surveyFlow.answers.pets.includes(t)}
          onClick={() => surveyFlow.togglePet(t)}
        >
          <Icon name="paw" size={15} /> {t}
        </button>
      ))}
      <button type="button" className="intake-pet" aria-pressed={!!none} onClick={surveyFlow.noPets}>
        <Icon name="ring" size={15} /> No pets
      </button>
    </div>
  );
}
